import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/red-packet/Index.vue')

export const redPacketRoute: RouteConfig = {
  path: '/activity/red-packet',
  name: 'activity_red_packet',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '返现红包',
    needLogin: true,
    needOpenidUnderWechat: true,
  },
}

export default [redPacketRoute]
